import { AboutPage } from "@web/pages/about/AboutPage";

export default function About() {
  return <AboutPage />;
}
